import React from "react";
import "./UploadTrainingSources.css";

const UploadTrainingSources = () => {
  return (
    <div className="xena-docs">
      <h1>Adding Knowledge Sources in XenaChat</h1>

      <p>
        To enhance your assistant’s performance, XenaChat allows you to upload
        structured knowledge sources. These sources enable your bot to provide
        accurate, contextual, and automated responses to user queries.
      </p>

      <h2>Why Training Data Matters</h2>
      <p>
        Your assistant depends on well-organized content to generate reliable
        answers. By adding documents, web links, or FAQ sets, you supply the
        information needed for smarter conversations.
      </p>

      <h2>Supported Upload Options</h2>
      <ul>
        <li>Uploading Documents (PDF, DOC, DOCX, TXT)</li>
        <li>Adding Web Links and Cloud Documents</li>
        <li>Creating FAQs and Answer Sets</li>
      </ul>

      <h2>What Happens After Uploading?</h2>
      <p>
        Once a knowledge source is added, XenaChat automatically processes and
        indexes the content. The system analyzes the structure, extracts key
        information, and prepares it for intelligent retrieval during user
        conversations.
      </p>

      <p>
        After processing is complete, your assistant can instantly reference
        the uploaded material to deliver accurate and context-aware responses.
      </p>
    </div>
  );
};

export default UploadTrainingSources;
